export { default as FilteredCardsSection } from './FilteredCardsSection';
